import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { LookupSelectPesquisavelResponse } from '../../responses/motor-fiscal/lookup-select-pesquisavel.response';
import { GetAnpProdutoLookupResponse } from '../../responses/motor-fiscal/get-anp-produto-lookup.response';

@Injectable({
  providedIn: 'root',
})
export class AnpLookupService extends CommonService {
  constructor(private httpClient: HttpClient) {
    super();
  }

  private readonly apiUrl = `${environment.urlApiMotorFiscal}Lookup`;

  public getRegimeIcms(): Observable<LookupSelectPesquisavelResponse> {
    return this.httpClient
      .get<LookupSelectPesquisavelResponse>(`${this.apiUrl}/regime-icms`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public getIndicadorImportacao(): Observable<LookupSelectPesquisavelResponse> {
    return this.httpClient
      .get<LookupSelectPesquisavelResponse>(`${this.apiUrl}/indicador-importacao`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public getNcmLookup(textoBusca: string): Observable<LookupSelectPesquisavelResponse> {
    const params = new HttpParams().set('textoBusca', textoBusca ?? '');
    return this.httpClient
      .get<LookupSelectPesquisavelResponse>(`${this.apiUrl}/ncm`, { ...this.addHeaderToken(), params })
      .pipe(catchError(this.handleError));
  }

  /**
   * Lookup ANP para o cadastro de produto: NCMs mapeados ativos + códigos ANP ativos
   * da empresa, numa única chamada. Endpoint sob JWT (não exige permissão de Configurações).
   */
  public getAnpParaProduto(): Observable<GetAnpProdutoLookupResponse> {
    return this.httpClient
      .get<GetAnpProdutoLookupResponse>(`${this.apiUrl}/anp`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
